<script>
import {defineComponent} from 'vue'
import WishListProduct from "@/features/wishlist/WishListProduct.vue";
import blockElementMixin from "@/mixins/blockElementMixin";
import {calcCols} from "@/features/wishlist/WishListHelpers";
import {mapGetters, mapState} from "vuex";

export default defineComponent({
	name: "WishListCard",
	components: {WishListProduct},
	mixins: [blockElementMixin],


	mounted() {
		this.blockData.colSpan = this.cols;
	},

	computed: {
		...mapGetters(['content', 'language']),
		...mapGetters('wishListStore', ['userFirstName']),
		...mapGetters('screen', ['displayMode', 'flyerOrientation']),
		...mapGetters('scale', ['defPage']),
		...mapState('wishListStore', {allProds: state => state.products}),

		lang() {
			return this.content?.feature?.wishlist || {};
		},

		products() {
			if(this.flyerOrientation === 'vertical') return this.allProds;
			return this.blockData?.props?.products || [];
		},
		cols() {
			const pc = this.products.length;
			return calcCols(pc, this.defPage.grids, this.flyerOrientation, this.displayMode);
			//return pc % 2 === 0 ?  (pc / 2) + 1 : (pc + 1) / 2;
		},
		colMode() {
			return this.products.length % 2 === 0 ? 'even' : 'odd';
		},
		style(){
			if(this.flyerOrientation === 'vertical') {
				return {
					gridTemplateColumns: `repeat(${this.cols}, 1fr)`,
					gridTemplateRows: `60px ${this.blockData.unitHeight * 2}px`,
				}
			}
			return {
				gridTemplateColumns: `repeat(${this.cols}, 1fr)`,
			}
		}
	},
	watch:{
		flyerOrientation(){
			this.blockData.colSpan = this.cols;
		},
		displayMode(){
			this.blockData.colSpan = this.cols;
		}
	}
})
</script>

<template>
	<div class="wish-list-card" :class="colMode" :style="style" :lang="language">
		<div class="price-drop-title-block">
			<div class="title">{{ lang.priceDrop }}</div>
			<div>{{userFirstName}}{{ lang.itemsIn }}!</div>
		</div>
		<wish-list-product v-for="product in products"
		                   :key="product.code"
		                   :product="product"/>
	</div>
</template>

<style lang="scss" scoped>
.wish-list-card {
  background-color: #FFEC94;
  display: grid;
  grid-template-rows: 1fr 1fr;
  grid-gap: 10px;
  padding: 10px;

  [flyer-orientation=vertical] & .price-drop-title-block {
	grid-area: auto / 1 / auto / -1;
	flex-direction: row;
	margin: -10px -10px 0px;
	[mode=mobile] & {
      flex-direction: column;
	  align-items: flex-start;
	  justify-content: center;
	  gap: 0;
    }
  }

  [flyer-orientation=horizontal] &.even {
	.price-drop-title-block {
	  grid-area: span 2;
	}
  }

  .price-drop-title-block {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 1em;
	padding: 1.2em;
	font-size: 13px;
    color: #fff;
    background-color: #D81E05;
    font-family: 'CTEastmanCondensed',sans-serif;
    font-weight: 500;
    line-height: 1.5em;
    .title {
      font-size: 2.4em;
      font-family: 'CTEastmanCompressed',sans-serif;
      font-weight: 800;
      line-height: 0.8em;
      text-transform: uppercase;
    }
  }
}
</style>
